import Footer from "layout/Footer";
import Layout from "layout/Layout";

import { useNavigate } from "react-router-dom";

import {
  detail_introduction,
  medmall_header,
  medmall_Introduction1,
  medmall_Introduction2,
  medmall_Introduction3,
  medmall_Introduction4,
  medmall_Introduction5,
  medmall_Introduction6,
  medmall_Introduction7,
  medmall_Introduction8,
  medmall_Introduction9,
  medmall_Introduction10,
  medmall_Introduction11,
} from "utils/linkData";

const Introduction = () => {
  let history = useNavigate();

  return (
    <div>
      <div
        className="display-center-margin-50-1"
        style={{ textAlign: "center" }}
      >
        <div>
          <div>
            <img
              src={medmall_Introduction11}
              alt="medmall_Introduction"
              className="img-w1080-Introduction11"
            ></img>
          </div>
          <img
            src={medmall_header}
            alt="medmall_header"
            className="img-w200"
            style={{ marginBottom: "21px" }}
          ></img>
        </div>
        <div>
          <span id="font-SCD7" className="span-blue2-25">
            아직도 비싼 가격으로 제품을 구매하고 계신가요 ?
          </span>
          <hr className="hr-green-w485"></hr>
        </div>
        <div style={{ marginBottom: "22px" }}>
          <span id="font-SCD4" className="span-f18"></span>

          <span className="span-red-accent-text" id="font-SCD6">
            좋은 품질의 제품
          </span>
          <span id="font-SCD4" className="span-f18">
            을{" "}
          </span>
          <span className="span-red-accent-text" id="font-SCD6">
            세상 어디에도 없는 저렴한 가격
          </span>
          <span id="font-SCD4" className="span-f18">
            으로 <br></br> 구매하실 수 있도록 준비하겠습니다.
          </span>
        </div>
        <button
          className="btn-blue-w130-Introduction"
          id="font-SCD6"
          onClick={() => history("/login")}
          style={{ position: "relative", zIndex: 2 }}
        >
          들어가기
        </button>
        <div style={{ zIndex: -1 }}>
          <img
            src={medmall_Introduction1}
            alt="medmall_Introduction1"
            className="img-w680"
            style={{ marginTop: "0px", zIndex: -1 }}
          ></img>
        </div>
        <div>
          <button
            className="btn-blue-transparent-w210"
            id="font-SCD7"
            onClick={() => window.open(detail_introduction)}
            style={{ position: "relative", zIndex: 2, marginTop: "30px" }}
          >
            메드몰은 무엇인가요?
          </button>
        </div>
        <div className="div-blue-h500" style={{ marginTop: "25px" }}>
          <div className="div-Introduction">
            {/* <div>
              <br></br>
              <span
                className="span-f20-accent-text"
                style={{
                  paddingBottom: "5px",
                  borderBottom: "1px solid #fff",
                }}
                id="font-SCD7"
              >
                먼저 2가지 건강기능식품이 준비되어 있습니다.
              </span>
              <br></br>
              <br></br>
            </div> */}
            {/* <div className="div-Introduction-2">
              <ul>
                <li>
                  <div style={{ textAlign: "center" }} id="font-SCD5">
                    <span>유산균 연구 100년 역사의</span>
                    <br />
                    <span>다니스코社의 특허균주 7종으로만 배합하였습니다.</span>
                  </div>
                  <br></br>
                  <img
                    src={medmall_Introduction2}
                    alt="medmall_Introduction2"
                    className="img-w380"
                    style={{ marginTop: "15px" }}
                  ></img>{" "}
                  <div
                    style={{
                      marginTop: "13px",
                      paddingBottom: "8px",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    <span className="span-f20-accent-text" id="font-SCD7">
                      액티브3포스트바이오틱스
                    </span>
                  </div>
                  <div className="div-Introduction2-detail">
                    <div
                      style={{ width: "116px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>프로바이오틱스</span>
                      <br></br>
                      <span>(주원료)</span>
                    </div>
                    <div
                      style={{
                        width: "20px",
                        float: "left",
                        marginTop: "6px",
                        fontSize: "25px",
                      }}
                      id="font-SCD7"
                    >
                      <span>+</span>
                    </div>
                    <div
                      style={{ width: "116px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>프리바이오틱스</span>
                      <br></br>
                      <span>(주원료)</span>
                    </div>
                    <div
                      style={{
                        width: "20px",
                        float: "left",
                        marginTop: "6px",
                        fontSize: "25px",
                      }}
                      id="font-SCD7"
                    >
                      <span>+</span>
                    </div>
                    <div
                      style={{ width: "138px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>유산균배양건조물</span>
                      <br></br>
                      <span>(부원료)</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div style={{ textAlign: "center" }} id="font-SCD5">
                    <span>프리미엄 식품 유래 영양소로 채운</span>
                    <br />
                    <span>
                      비건(Vegan) 인증(한국비건인증원) 멀티비타민 입니다.
                    </span>
                  </div>
                  <br></br>
                  <img
                    src={medmall_Introduction3}
                    alt="medmall_Introduction3"
                    className="img-w380"
                    style={{ marginTop: "15px" }}
                  ></img>{" "}
                  <div
                    style={{
                      marginTop: "13px",
                      paddingBottom: "8px",
                      borderBottom: "1px solid #fff",
                    }}
                  >
                    <span className="span-f20-accent-text" id="font-SCD7">
                      액티브그린멀티비타민
                    </span>
                  </div>
                  <div className="div-Introduction2-detail">
                    <div
                      style={{ width: "115px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>비타민 11종</span>
                    </div>
                    <div
                      style={{
                        width: "20px",
                        float: "left",
                        marginTop: "-5px",
                        fontSize: "25px",
                      }}
                      id="font-SCD7"
                    >
                      <span>+</span>
                    </div>
                    <div
                      style={{ width: "100px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>미네랄 8종</span>
                    </div>
                    <div
                      style={{
                        width: "20px",
                        float: "left",
                        marginTop: "-5px",
                        fontSize: "25px",
                      }}
                      id="font-SCD7"
                    >
                      <span>+</span>
                    </div>
                    <div
                      style={{ width: "155px", float: "left" }}
                      id="font-SCD6"
                    >
                      <span>엄선한 부원료 10종</span>
                    </div>
                  </div>
                </li>
              </ul>
              <div className="btn-detail-item">
                <button
                  id="font-SCD5"
                  onClick={() =>
                    window.open(
                      "https://redandblue.notion.site/Product-6f9405c783f640418d4da7c97eb4eb55"
                    )
                  }
                >
                  상세보기
                </button>
              </div>
            </div> */}
            {/* <div className="div-Introduction9" id="font-SCD6">
              <div style={{ float: "left", position: "relative" }}>
                <img
                  className="img-w180-Introduction9"
                  src={medmall_Introduction9}
                  alt="medmall_Introduction9"
                ></img>
              </div>
              <div style={{ float: "left", position: "relative" }}>
                <div style={{ marginTop: "25px" }}></div>
                <span>
                  건강기능식품, 전자기기, 의료기기, 화장품 등 좋은 상품을
                </span>
                <div style={{ marginTop: "15px" }}></div>
                <span>
                  인터넷 최저가격보다 저렴하게 준비하여 입고시 안내드릴 수
                  있도록 하겠습니다.
                </span>
              </div>
            </div> */}
            <div>
              <img
                className="img-w1080-Introduction10"
                src={medmall_Introduction10}
                alt="medmall_Introduction10"
              ></img>
            </div>
          </div>
        </div>
        <div style={{ clear: "both" }} className="div-Introduction-3"></div>

        <div style={{ marginTop: "100px" }}>
          <span className="span-blue2-24" id="font-SCD7">
            MEDMall 이용하기
          </span>
          <hr style={{ width: "210px", border: "solid 1px #eaeaea" }}></hr>
          <img
            src={medmall_Introduction4}
            alt="medmall_Introduction4"
            className="img-w1050"
            style={{ marginTop: "15px" }}
          ></img>{" "}
        </div>
        <div style={{ marginTop: "30px" }}>
          <button
            className="btn-blue-w130-Introduction"
            id="font-SCD6"
            onClick={() => history("/login")}
            style={{ position: "relative", zIndex: 2 }}
          >
            들어가기
          </button>
        </div>
        {/* 가치공유플랫폼 소개 */}
        {/* <div style={{ clear: "both" }}>
        <div className="div-kobama-introduction">
          <div>
            <div className="div-kobama-l">
              <img
                src={medmall_Introduction5}
                alt="medmall_Introduction5"
                className="img-w300-introduction5"
                style={{}}
              ></img>{" "}
            </div>
            <div className="div-kobama-r">
              <div>
                <div style={{ float: "left" }}>
                  <img
                    src={medmall_Introduction6}
                    alt="medmall_Introduction6"
                    className="img-w270-Introduction6"
                    style={{}}
                  ></img>{" "}
                </div>
                <div
                  style={{ float: "right", textAlign: "right" }}
                  className="div-kobama-r-text"
                >
                  <span id="font-SCD5">MEDMall 가입하시면</span>
                  <br />
                  <span id="font-SCD5">동일한 계정(아이디)정보로</span>
                  <br />
                  <br />
                  <span id="font-SCD7" style={{ color: "#525499" }}>
                    별도의 추가적인
                  </span>
                  <br />
                  <span id="font-SCD7" style={{ color: "#525499" }}>
                    회원가입 절차 없이
                  </span>
                  <br />
                  <br />
                  <span id="font-SCD5">대한밸런스의학회에서 운영하는</span>
                  <br />
                  <span id="font-SCD5">가치를 더하고, 같이 나누기 위한</span>
                  <br />
                  <span id="font-SCD7" style={{ color: "#525499" }}>
                    '가치 공유 플랫폼'의 서비스를
                  </span>
                  <br />
                  <span id="font-SCD7" style={{ color: "#525499" }}>
                    이용하실 수 있습니다.
                  </span>
                  <br />
                </div>
              </div>
              <div style={{ clear: "both", marginBottom: "15px" }}></div>
              <div>
                <img
                  src={medmall_Introduction7}
                  alt="medmall_Introduction7"
                  className="img-w200"
                  style={{ float: "left" }}
                ></img>{" "}
                <label className="div-kobama-label"></label>
                <button
                  className="btn-blue-w130-Introduction"
                  id="font-SCD6"
                  onClick={() => window.open(siteLink_kobama)}
                  style={{ position: "relative", zIndex: 2 }}
                >
                  바로가기
                </button>
              </div>
              <div style={{ clear: "both", marginBottom: "20px" }}></div>
              <div style={{ float: "left" }}>
                <img
                  src={medmall_Introduction8}
                  alt="medmall_Introduction8"
                  className="img-w480-Introduction8"
                ></img>{" "}
              </div>
            </div>
          </div>
        </div>
      </div> */}
        {/* 하단공백 */}
        <div style={{ clear: "both", marginBottom: "40px" }}></div>
        {/* <hr></hr> */}
      </div>
      <Footer></Footer>
    </div>
  );
};

export default Introduction;
